import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from "axios";
import Header from '../Header';
import Footer from '../Footer';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link, useParams } from 'react-router-dom';
import { format } from 'date-fns';
import { API_URL, BASE_URL } from '../Config';
import config from "../common/Config";
import AccountService from '../../services/AccountServices';
import * as XLSX from 'xlsx';

const ProductLedgerView = () => {
	const accessToken = localStorage.getItem('accessToken');
	const user_id = localStorage.getItem('userId');
	const { productId, startDate, endDate, orderType } = useParams();

	const [dates, setDates] = useState([null, null]);
	const [resStartDate, setResStartDate] = useState('');
	const [resEndDate, setResEndDate] = useState('');
	const [reportrange, setReportrange] = useState('');
	const [productOptions, setProductOptions] = useState([]);
	const [productFilteredOptions, setProductFilteredOptions] = useState([]);
	const [productValue, setProductValue] = useState(null);
	const [searchValue, setSearchValue] = useState([]);
	const productLadgerRef = useRef(null);

	const searchFormData = () => {
		const startDateFormatted = dates[0] ? format(dates[0], 'dd/MM/yyyy') : '';
		const endDateFormatted = dates[1] ? format(dates[1], 'dd/MM/yyyy') : '';
		setReportrange(startDateFormatted ? `${startDateFormatted} - ${endDateFormatted}` : '');
		getProductLedgerList();
	};



	// Fetch product ledger list
	const getProductLedgerList = () => {
		const $table = $(productLadgerRef.current);

		const startDateFormatted = dates[0] ? format(dates[0], 'dd/MM/yyyy') : '';
		const endDateFormatted = dates[1] ? format(dates[1], 'dd/MM/yyyy') : '';
		const searchValue = $('#searchValue').val();

		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}

		$table.DataTable({
			processing: true,
			serverSide: true,
			ajax: {
				url: `${config.API_URL}/view_product_ledger_details`,
				type: 'POST',
				headers: { authorization: `Bearer ${accessToken}` },
				data: function (d) {
					return $.extend({}, d, {
						start: d.start,
						length: d.length,
						searchValue: searchValue,
						product_id: productId || '',
						start_date: startDate || '',
						end_date: endDate || '',
						order_type: orderType || '',
					});
				},
				dataSrc: function (json) {
					if (json) {
						let openingBalanceRow = {
							date: '',
							order_no: '',
							code: '',
							name: '',
							order_type: '',
							status: 'O/B',
							qty: '',
							bal: json.data[0].order_type === 'box'
								? json.data[0].box_system_qty || 0
								: json.data[0].piece_system_qty || 0
						};
						json.data.unshift(openingBalanceRow);

						setResStartDate(json.start_date);
						setResEndDate(json.end_date);
					}
					return Array.isArray(json.data) ? json.data : [];
				},
			},
			language: {
				paginate: { first: 'First', last: 'Last', next: 'Next', previous: 'Previous' },
				search: 'Search:',
			},

			columns: [
				{ data: 'date' },
				{
					data: 'order_no',
					render: function (data, type, row) {
						let url = '';

						if (row.status === 'Accept') {
							url = `${config.BASE_URL}/new_sales/invoice/${row.sale_id}`;
						} else {
							url = `${config.BASE_URL}/trip_summary/print/${row.sale_id}`;
						}

						return `
				<a href="${url}" title="Print Invoice">
					 ${data}
				</a>
				`;
					}

				},
				{ data: 'code' },

				{ data: 'name' },
				{ data: 'order_type' },
				{ data: 'status' },
				{ data: 'qty' },
				{
					data: 'bal',
					render: function (data, type, row) {
						if (row.order_type === 'box') {
							return `<span style="text-align: right;">${row.actual_box_balance || ''}</span>`;
						} else if (row.order_type === 'piece') {
							return `<span style="text-align: right;">${row.actual_piece_balance || ''}</span>`;
						} else {
							return `<span style="text-align: right;">${data || ''}</span>`;
						}
					}
				},
			],
			columnDefs: [
				{ orderable: false, targets: '_all' },
			],
			pageLength: 50,
		});
	};

	const handleExport = async () => {
		try {
			// Call your export API (same filters as DataTable, but without pagination params)
			const response = await axios.post(
				`${config.API_URL}/view_product_ledger_details_export`,
				{
					searchValue: $('#searchValue').val() || '',
					product_id: productId || '',
					start_date: startDate || '',
					end_date: endDate || '',
					order_type: orderType || ''
				},
				{
					headers: { authorization: `Bearer ${accessToken}` }
				}
			);



			if (!response.data.data || !Array.isArray(response.data.data)) {
				alert("No data found to export.");
				return;
			}

			// Format export data
			const exportData = response.data.data.map(row => ({
				Date: row.date || '',
				Code: row.code || '',
				Product: row.name || '',
				Type: row.order_type || '',
				Transaction: row.status || '',
				Qty: row.qty != null && row.qty !== '' ? parseFloat(row.qty) : '',
				Balance:
					row.order_type === 'box'
						? (row.actual_box_balance != null && row.actual_box_balance !== '' ? parseFloat(row.actual_box_balance) : '')
						: row.order_type === 'piece'
							? (row.actual_piece_balance != null && row.actual_piece_balance !== '' ? parseFloat(row.actual_piece_balance) : '')
							: (row.bal != null && row.bal !== '' ? parseFloat(row.bal) : '')
			}));


			// Convert to worksheet
			const ws = XLSX.utils.json_to_sheet(exportData);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "Product Ledger");

			// Export to file
			XLSX.writeFile(wb, `Product_Ledger_${new Date().toISOString().slice(0, 10)}.xlsx`);
		} catch (error) {
			console.error("Error exporting data:", error);
			alert("Failed to export data.");
		}
	};



	useEffect(() => {
		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		getProductLedgerList();

		return () => {
			if (productLadgerRef.current && $.fn.DataTable.isDataTable(productLadgerRef.current)) {
				$(productLadgerRef.current).DataTable().destroy();
			}
		};
	}, [accessToken, searchValue, resStartDate, resEndDate]);

	return (
		<>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/account/my_ledger">Account</Link>
							<Link to="/account/product_ledger">Product Ledger View</Link>
						</div>
					</div>
				</div>
			</div>

			<div className="main-container">
				<div className="container-fluid">
					<div className="total-manifests-area dashboard" style={{ position: 'relative' }}>
						<button
							className="acceptbtn"

							onClick={handleExport}
						>
							Export
						</button>
						<div className="verical-scrl-wrapper productledgerview autoheight-table" id="style-3">


							<table className="table table-bordered dataTable resizable" id="productLadgerList" ref={productLadgerRef}>
								<thead>
									<tr>
										<th>Date</th>
										<th>Order/Inv No.</th>
										<th>Code</th>
										<th>Product</th>
										<th>Type</th>
										<th>Transaction</th>
										<th>Qty</th>
										<th>Balance</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1</td>
										<td>2</td>
										<td>3</td>
										<td>4</td>
										<td>5</td>
										<td>6</td>
										<td>7</td>
										<td>7</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
};

export default ProductLedgerView;
